// Only initialize if not embedded in an iFrame
if (window.top === window.self) {
  window.addEventListener('DOMContentLoaded', function () {
    var $megaMenu = document.querySelector('.aps-mega-menu')

    if ($megaMenu) {
      var $activeLinks, $activeForward
      var $back = $megaMenu.querySelector('.aps-mega-menu__back')

      Array.from($megaMenu.querySelectorAll('.aps-mega-menu__links')).forEach(function ($links) {
        Array.from($links.querySelectorAll('.aps-mega-menu__forward')).forEach(function ($forward) {
          $forward.addEventListener('click', function (ev) {
            ev.preventDefault()
            ev.stopPropagation()
            $links.style.minHeight = window.getComputedStyle($links).height
            $links.classList.add('aps-mega-menu__links--level-3')
            $forward.parentNode.classList.add('aps-mega-menu__list--active')
            $activeLinks = $links
            $activeForward = $forward
          })
        })
      })

      $back.addEventListener('click', function (ev) {
        ev.preventDefault()
        if ($activeLinks && $activeLinks.classList.contains('aps-mega-menu__links--level-3')) {
          ev.stopPropagation()
          $activeForward.parentNode.classList.remove('aps-mega-menu__list--active')
          $activeLinks.classList.remove('aps-mega-menu__links--level-3')
          $activeForward = null
        }
      })

      window.aps.$megaMenu = $megaMenu
    }
  })
}
